export enum UserRole {
  AdminQcs = 'ADMIN_QCS',
  AdminCompany = 'ADMIN_COMPANY',
  ManagerOsah = 'MANAGER_OSAH',
  ManagerWorkplace = 'MANAGER_WORKPLACE',
  Receptionist = 'RECEPTIONIST',
  Tourniquet = 'TOURNIQUET',
  TourniquetTraining = 'TOURNIQUET_TRAINING',
  Training = 'TRAINING',
  ExternalManager = 'EXTERNAL_MANAGER',
  ExternalOneTime = 'EXTERNAL_ONE_TIME',
  ExternalWorker = 'EXTERNAL_WORKER',
  RemoteToken = 'REMOTE_TOKEN',
  HwTurnstile = 'HW_TURNSTILE',
  Analyst = 'ANALYST',
}
